import { MfeReactComponent } from '@carvana/microfrontend-react';
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import telemetryService from '|/app/services/telemetry/telemetry-service';
import { DataDogTeamTags } from '|/app/services/telemetry/telemetry-types';
import { useBrand } from '|/brand';
import ErrorPage from '|/components/base/error';
import Loading from '|/components/base/loading';
import { DevicePlatformContext } from '|/context';
import PurchaseContext from '|/context/purchase-context';
import useDocumentTitle from '|/hooks/use-document-title';
import { loadOpdMfe } from '|/hooks/use-global-mfe-config';
import useNavigateAwayFromPurchase from '|/hooks/use-navigate-away-from-purchase';
import useNavigateInPurchase from '|/hooks/use-navigate-in-purchase';

const OPD_MODULE = 'OrderPlacedDashboardModule';
const MFE_LOAD_TIMEOUT_MS = 30000;

const OpdMfeRoute: React.FC = () => {
  const { pathname } = useLocation();
  const { vehicleId } = useContext(PurchaseContext);
  const devicePlatform = useContext(DevicePlatformContext);
  const { identity } = useBrand();
  const navigateInPurchase = useNavigateInPurchase();
  const navigateAwayFromPurchase = useNavigateAwayFromPurchase();

  useDocumentTitle('Order Placed');

  useEffect(() => {
    loadOpdMfe();
  }, []);

  return (
    <MfeReactComponent
      module={OPD_MODULE}
      component="default"
      currentPath={pathname}
      vehicleId={vehicleId}
      devicePlatform={devicePlatform}
      source={identity.mfeBrand}
      theme={identity.mfeBrand}
      onNavigateInPurchase={navigateInPurchase}
      onNavigateAwayFromPurchase={navigateAwayFromPurchase}
      loading={<Loading />}
      fallback={{ Component: <ErrorPage />, timeout: MFE_LOAD_TIMEOUT_MS }}
      onComponentError={({ id, error }: { id: string; error?: Error }) => {
        telemetryService.trackError({
          name: 'opd-mfe:error',
          error: new Error(`OPD MFE component failed: ${id}`, { cause: error }),
          context: {
            customType: 'errorBoundary',
            team: DataDogTeamTags.Verifx,
            mfe: OPD_MODULE,
            mfeComponentId: id
          }
        });
      }}
    />
  );
};

export default OpdMfeRoute;
